module.exports = __webpack_public_path__ + "static/space_shuttle-e1a9352d10a9d67616283f35706a7555.jpeg";